import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import CruiseList from '@/views/CruiseList.vue'
import CruiseLineComparison from '@/views/CruiseLineComparison.vue'
import BestDeals from '@/views/BestDeals.vue'
// Deals CLS: static like BestDeals / CruiseList. A lazy chunk left <main> empty for ~0.6s on a slow link, so the
// footer sat in the first viewport and jumped when the page mounted (Hot Deals desktop CLS).
import HotDeals from '@/views/HotDeals.vue'
import CruiseDetail from '@/views/CruiseDetail.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/cruises',
    name: 'CruiseList',
    component: CruiseList
  },
  {
    // CP-202: only numeric ids are sailings; /cruise/abc falls through to the NotFound catch-all.
    path: '/cruise/:id(\\d+)',
    name: 'CruiseDetail',
    component: CruiseDetail
  },
  {
    path: '/comparison',
    name: 'CruiseLineComparison',
    component: CruiseLineComparison
  },
  {
    path: '/best-deals',
    name: 'BestDeals',
    component: BestDeals
  },
  {
    path: '/hot-deals',
    name: 'HotDeals',
    component: HotDeals
  },
  {
    path: '/manage-alerts',
    name: 'ManageAlerts',
    component: () => import('@/views/ManageAlerts.vue')
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  {
    path: '/terms',
    name: 'TermsOfUse',
    component: () => import('@/views/TermsOfUse.vue')
  },
  {
    path: '/disclosure',
    name: 'AffiliateDisclosure',
    component: () => import('@/views/AffiliateDisclosure.vue')
  },
  // Legacy/aliased paths — redirect to working pages (CP-41).
  {
    path: '/browse',
    redirect: { name: 'CruiseList' }
  },
  {
    path: '/affiliate',
    redirect: '/disclosure'
  },
  {
    path: '/affiliate-disclosure',
    redirect: '/disclosure'
  },
  // Admin routes
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/AdminLogin.vue')
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import('@/views/admin/AdminDashboard.vue'),
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/reviews',
    name: 'AdminReviews',
    component: () => import('@/views/admin/AdminReviews.vue'),
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/deals',
    name: 'AdminDeals',
    component: () => import('@/views/admin/AdminDeals.vue'),
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/scraper',
    name: 'AdminScraper',
    component: () => import('@/views/admin/AdminScraper.vue'),
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/alerts',
    name: 'AdminAlerts',
    component: () => import('@/views/admin/AdminAlerts.vue'),
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/cruises',
    name: 'AdminCruises',
    component: () => import('@/views/admin/AdminCruises.vue'),
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/stats',
    name: 'AdminStats',
    component: () => import('@/views/admin/AdminStats.vue'),
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/x-posts',
    name: 'AdminXPosts',
    component: () => import('@/views/admin/AdminXPosts.vue'),
    meta: { requiresAdmin: true }
  },
  // Catch-all 404 — must be LAST.
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Admin navigation guard
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAdmin) {
    const key = sessionStorage.getItem('cruise-admin-api-key')
    if (!key) {
      next({ name: 'AdminLogin', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
